import React, { useEffect, useState } from 'react';
import { Button, Checkbox, Form, Input, InputNumber, Row, Col } from 'antd';
import { GetById_SubPeriod_Api, Update_SubPeriod_Api } from '../../API/SubPeriodApi';
import { AllCategoryComponent } from '../Category/AllCategoryComponent';
import { RollbackOutlined, CheckOutlined } from '@ant-design/icons';

// -----------------------------------------------------------
// وارد کردن DatePicker و تنظیمات شمسی (جایگزین antd-jalali و dayjs)
import DatePicker, { DateObject } from "react-multi-date-picker";
import persian from "react-date-object/calendars/persian";
import persian_fa from "react-date-object/locales/persian_fa";
// -----------------------------------------------------------


// =================================================================
const SERVER_DATE_FORMAT = "YYYY-MM-DD"; 

/**
 * تابع کمکی برای تبدیل ارقام فارسی/عربی به انگلیسی و تبدیل اسلش به خط تیره.
 */
const persianToEnglishNumbers = (str) => {
    if (!str) return '';
    let output = String(str).trim(); 

    const persianNumbers = [/۰/g, /۱/g, /۲/g, /۳/g, /۴/g, /۵/g, /۶/g, /۷/g, /۸/g, /۹/g];
    const arabicNumbers = [/٠/g, /١/g, /٢/g, /٣/g, /٤/g, /٥/g, /٦/g, /٧/g, /٨/g, /٩/g];
    const englishNumbers = ['0', '1', '2', '3', '4', '5', '6', '7', '8', '9'];

    for (let i = 0; i < 10; i++) {
        output = output.replace(persianNumbers[i], englishNumbers[i]);
        output = output.replace(arabicNumbers[i], englishNumbers[i]);
    }

    return output.replace(/\//g, "-"); 
};

// =================================================================
/**
 * آداپتور سفارشی برای اتصال react-multi-date-picker به Form.Item آنت‌دیزاین.
 * خروجی همیشه YYYY-MM-DD با ارقام انگلیسی است.
 */
const PersianDatePickerAdapter = ({ value, onChange }) => {
    const [dateValue, setDateValue] = useState(null);

    const toDateObject = (dateString) => {
        if (!dateString) return null;
        const englishDateString = persianToEnglishNumbers(dateString); 
        
        return new DateObject({
            calendar: persian,
            locale: persian_fa,
            date: englishDateString,
            format: SERVER_DATE_FORMAT 
        });
    };
    
    useEffect(() => {
        // تنظیم مقدار اولیه از Form.Item (که از سرور لود شده)
        // مقدار value باید همان string تاریخ از سرور باشد (مثلاً "1403/01/01")
        setDateValue(toDateObject(value));
    }, [value]);

    const handleOnChange = (dateObject) => {
        setDateValue(dateObject); 

        let dateString = null;
        if (dateObject) {
            const persianDateString = Array.isArray(dateObject) ? 
                         dateObject.map(d => d.format(SERVER_DATE_FORMAT)) : 
                         dateObject.format(SERVER_DATE_FORMAT);
            // تبدیل ارقام فارسی به انگلیسی و اسلش به خط تیره در لحظه خروج
            dateString = persianToEnglishNumbers(persianDateString);
        }
        
        // ارسال مقدار رشته‌ای تمیز و انگلیسی (با خط تیره) به Form.Item
        onChange(dateString);
    };

    return (
        <DatePicker
            calendar={persian}
            locale={persian_fa}
            value={dateValue}
            onChange={handleOnChange}
            inputClass="ant-input persian-date-input" 
            calendarPosition="bottom-right"
            format={SERVER_DATE_FORMAT} 
        />
    );
};
// =================================================================

export const EditSubPeriodComponent = ({ setLoading, showMessage, id, periodCategoryId, rowUpdated, cancelEdit }) => {
    // ======================================================================
    const [subPeriod, setSubPeriod] = useState();
    const [categoryId, setCategoryId] = useState(-1);
    
    // State های مربوط به تقویم antd-jalali (مثل fromDate, fromDateBase و...) حذف شدند
    
    const [form] = Form.useForm()
    // =================================================================
    useEffect(() => {
        loadData();
    }, [id]);
    // =================================================================
    const loadData = async () => {
        setLoading(true);
        try {
            const data = await GetById_SubPeriod_Api(id);
            setLoading(false);
            if (data.messageStatus === "Successful") {
                const subPeriodData = data.messageData.data;
                setSubPeriod(subPeriodData);
                setCategoryId(subPeriodData.categoryId);
                
                // فرمت تاریخ‌ها در subPeriodData.from_Shamsi و to_Shamsi باید توسط PersianDatePickerAdapter خوانده شوند
                form.setFieldsValue(subPeriodData);

            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    }
    // =================================================================
    const onSubmit = async (values) => {
        setLoading(true);
        try {
            // مقادیر from_Shamsi و to_Shamsi توسط PersianDatePickerAdapter به صورت YYYY-MM-DD انگلیسی تنظیم شده‌اند
            values.categoryId = categoryId;
            let data = await Update_SubPeriod_Api(values);
            setLoading(false);

            if (data.messageStatus === "Successful") {
                showMessage(data.message, "Successful")
                rowUpdated();
            }
            else
                showMessage(data.message, "error")
        }
        catch (error) {
            setLoading(false);
            showMessage("خطا در ارتباط با سرور.", "error")
        }
    };
    // =================================================================
    const onFinishFailed = (errorInfo) => {
        // !!! رفع مشکل رندر آبجکت خطا: تبدیل آبجکت خطا به رشته
        const errorFields = errorInfo.errorFields;
        let errorMessage = "خطا در تکمیل فرم. فیلدهای زیر مشکل دارند: \n";
        
        if (errorFields && errorFields.length > 0) {
            errorFields.forEach(field => {
                const fieldName = field.name.join(' '); 
                const fieldErrors = field.errors.join(' | '); 
                errorMessage += `\n ${fieldName}: ${fieldErrors}`;
            });
        } else {
             errorMessage = "خطا در تکمیل فرم: " + JSON.stringify(errorInfo);
        }

        showMessage(errorMessage, "error");
    };
    // =================================================================
    // توابع initFromDateShamsi و initToDateShamsi حذف شدند زیرا دیگر نیازی به dayjs نیست.
    // =================================================================
    
    return (
        <>
            {subPeriod ? (
                <>
                    <div className='sectionTitle'>
                        <h2 >
                            ویرایش {subPeriod.title}
                        </h2>
                    </div>

                    <div className='container'>
                        <Form
                            name="basic"
                            form={form}
                            labelCol={{ span: 4 }}
                            wrapperCol={{ span: 20 }}
                            onFinish={onSubmit}
                            onFinishFailed={onFinishFailed}
                        >
                            <Form.Item name="id" hidden={true} />
                            <Form.Item name="periodId" hidden={true} />
                            
                            <Form.Item
                                name="title"
                                label="عنوان"
                                rules={[{ required: true, message: 'لطفاً عنوان را وارد کنید!' }]}
                            >
                                <Input placeholder='عنوان' />
                            </Form.Item>

                            <Form.Item
                                name="comment"
                                label="شرح"
                            >
                                <Input placeholder='شرح' />
                            </Form.Item>

                            <Form.Item
                                label="دسته"
                            >
                                <AllCategoryComponent
                                    setLoading={setLoading}
                                    showMessage={showMessage}
                                    parentId={periodCategoryId}
                                    isShowAddSubCategory={false}
                                    isShowEdit={false}
                                    isShowDelete={false}
                                    isLoadObjectInstanceCategories={false}
                                    isLoadCategoryFromParam={true}
                                    selectedCategory={categoryId}
                                    isShowCheckBox={true}
                                    onCheckChange={(catId, checked) => { if (checked) setCategoryId(catId); }}
                                />

                            </Form.Item>


                            {/* جایگزین DatePickerJalali با PersianDatePickerAdapter */}
                            <Form.Item
                                name="from_Shamsi"
                                label="از تاریخ"
                                rules={[{ required: true, message: 'لطفاً تاریخ شروع را انتخاب کنید!' }]}
                            >
                                {/* از آداپتور به عنوان کامپوننت Input در Form.Item استفاده می‌شود */}
                                <PersianDatePickerAdapter />
                            </Form.Item>

                            <Form.Item
                                name="to_Shamsi"
                                label="تا تاریخ"
                                rules={[{ required: true, message: 'لطفاً تاریخ پایان را انتخاب کنید!' }]}
                            >
                                <PersianDatePickerAdapter />
                            </Form.Item>

                            <Form.Item
                                name="orderIndex"
                                label="ترتیب"
                            >
                                <InputNumber />
                            </Form.Item>

                            <Form.Item
                                name="isActive"
                                label="فعال"
                                valuePropName='checked'
                            >
                                <Checkbox />
                            </Form.Item>
                        </Form>
                    </div>

                    <Row className='sectionFooter'>
                        <Col xs={0} sm={0} md={8} lg={16} xl={16} />
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                style={{ width: '98%' }}
                                className='btn-primary'
                                htmlType="submit"
                                onClick={() => form.submit()}>
                                <CheckOutlined />
                                ذخیره
                            </Button>
                        </Col>
                        <Col xs={12} sm={12} md={8} lg={4} xl={4} >
                            <Button
                                className='btn-secondary'
                                style={{ width: '100%' }}
                                onClick={() => cancelEdit()}>
                                <RollbackOutlined />
                                لغو </Button>
                        </Col>
                    </Row>
                </>
            )
                : (<></>)}
        </>
    )
}